import type { Selector } from 'core/core.selectors';
import type { AuthState } from 'core/services/auth/auth.models';

export const getUserData: Selector<AuthState> = state => state.uiState.auth;
